export default __webpack_public_path__ + "static/media/acne-vulgarisp.db5a598e.pdf";